import React from "react";
import { useAuth } from "./context/AuthContext";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 z-50">
                <div className="text-center">
                    <div className="w-16 h-16 mx-auto mb-4">
                        <img
                            src={require("../assets/logo/logo.svg").default}
                            alt="Logo"
                            className="w-full h-full object-contain animate-pulse"
                        />
                    </div>
                    <p className="text-gray-600 font-medium">Loading your dashboard...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/company/login" replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;